module.exports = __webpack_public_path__ + "assets/f5b05dbdb1bac716b9e23dc329ec548f.mp3";